import { apiUrl } from "../enviroments/enviroments.dev";
import { CreateWallet, WalletAddCredit, WalletAddCreditPayload } from "../models/Wallet";
import { Api } from "./Api";

const target = "/wallets";
const targethw = "/hard-wallets";

export class WalletService {

    public static getWalletByOrganization (id:number|null) {
        return Api.get(apiUrl(target+"/"+id));
    }

    public static getHwByUserId (id:number) {
        return Api.get(apiUrl(targethw+"/"+id));
    }

    // Cadastro simples de carteira (hash + rede como string).
    public static createSimpleWallet (userId:number, payload:{ hash:string; network:string }) {
        return Api.post(apiUrl(targethw+"/simple/"+userId), payload);
    }

    public static createWallet (payload:CreateWallet, id:number) {
        return Api.post(apiUrl(targethw+"/external/"+id), {payload});
    }

    public static getOrgWallets (id:number) {
        return Api.get(apiUrl(target+"/organizations/"+id));
    }

    public static addCredit (payload: WalletAddCreditPayload) {
        return Api.post(apiUrl("/wallets/credit"), payload);
    }

}
